module.exports = __webpack_public_path__ + "static/media/tripsavvi_no_city_large.c0359b61.png";